document.addEventListener('DOMContentLoaded', function () {

  let discountMultiplier = window.theme.productAddOns.discountMultiplier || 1;
  if (window.theme.productAddOns && window.theme.productAddOns.discountMultiplier) {
    discountMultiplier = window.theme.productAddOns.discountMultiplier
  }

  let customerTags = window.theme.productAddOns.customer ? window.theme.productAddOns.customer.customerTags : [];
  let checkTags = window.theme.productAddOns.taxSettings.checkTags || [];
  let incTaxSuffix = window.theme.productAddOns.languages.incTaxSuffix || '';
  let excTaxSuffix = window.theme.productAddOns.languages.excTaxSuffix || '';
  let outOfStock = window.theme.productAddOns.languages.outOfStock || '';

  let taxSuffix = incTaxSuffix;
  let taxDivisor = 1;
  let tagMatchFound = customerTags.some(tag => checkTags.includes(tag.toLowerCase()));
  if (tagMatchFound) {
    taxSuffix = excTaxSuffix;
    taxDivisor = parseFloat(1 + (window.theme.productAddOns.taxSettings.tax / 100));
  }

  function formatPrice(priceToFormat) {
    let formattedPrice = window.Shopify.formatMoney(priceToFormat, window.Shopify.money_format);
    return `${formattedPrice} <br/><span class="tax-suffix">${taxSuffix}</span>`;
  }

  function formatPriceShort(priceToFormat) {
    let formattedPrice = window.Shopify.formatMoney(priceToFormat, window.Shopify.money_format);
    return `${formattedPrice}`;
  }

  function getDiscountedPrice(price, discountMultiplier) {
    return price * discountMultiplier;
  }

  function extractNumberFromPrice(priceString) {
    // Check for the format "1.234,56" and convert to "1234.56"
    if (priceString.lastIndexOf(",") > priceString.lastIndexOf(".") && /,\d{2}$/.test(priceString)) {
      priceString = priceString.replace(/\./g, "").replace(",", ".");
    }
    // Check for the format "1,234.56" and convert to "1234.56"
    else if (priceString.lastIndexOf(".") > priceString.lastIndexOf(",") && /\.\d{2}$/.test(priceString)) {
      priceString = priceString.replace(/,/g, "");
    }

    let numberValue = parseFloat(priceString.replace(/[^0-9.]/g, ''));

    return numberValue.toFixed(2);
  }


  function updateTotalSummary() {
    const productAmountElement = document.querySelector('.summary-row__product .summary-row__amount');
    const addOnsAmountElement = document.querySelector('.summary-row__add-ons .summary-row__amount');
    const totalAmountElement = document.querySelector('.summary-row__total .summary-row__amount');

    const productPrice = parseFloat(extractNumberFromPrice(productAmountElement.textContent) * 100);
    const addOnsPrice = parseFloat(extractNumberFromPrice(addOnsAmountElement.textContent) * 100);

    totalAmountElement.innerHTML = formatPrice(productPrice + addOnsPrice);
  }


  const quantitySelectors = document.querySelectorAll('.add-on-quantity-selector__wrapper');
  const variantSelectors = document.querySelectorAll('.add-on-product__select');

  function checkAvailability(rowElement, selectedOption = null) {
    const variantInput = rowElement.querySelector('.add-on-product__input');
    const quantityInput = rowElement.querySelector('.add-on-product__quantity');
    const quantitySelector = rowElement.querySelector('.add-on-quantity-selector__wrapper');
    let availability;

    let outOfStockMessage = rowElement.querySelector('.out-of-stock-message') || document.createElement('p');
    outOfStockMessage.className = 'out-of-stock-message';
    outOfStockMessage.textContent = outOfStock;
    outOfStockMessage.style.color = 'red';

    if (selectedOption) {
      availability = selectedOption.getAttribute('data-add-on-variant-available');
    } else {
      availability = rowElement.querySelector('[data-add-on-variant-available]').dataset.addOnVariantAvailable;
    }

    if (availability === 'false') {
      if (variantInput) variantInput.setAttribute('disabled', 'disabled');
      if (quantityInput) quantityInput.setAttribute('disabled', 'disabled');

      rowElement.classList.add('unavailable');

      quantitySelector.style.display = 'none';
      if (!rowElement.querySelector('.out-of-stock-message')) {
        rowElement.querySelector('.add-on-product__variant').appendChild(outOfStockMessage);
      }
    } else {
      if (variantInput) variantInput.removeAttribute('disabled');
      if (quantityInput) quantityInput.removeAttribute('disabled');

      rowElement.classList.remove('unavailable');

      quantitySelector.style.display = 'inline-flex';
      if (rowElement.querySelector('.out-of-stock-message')) {
        rowElement.querySelector('.out-of-stock-message').remove();
      }
    }
  }




  const updatePrice = function (rowElement) {
    const quantityInput = rowElement.querySelector('[data-add-on-quantity-input]');
    const hiddenInput = rowElement.querySelector('.add-on-product__quantity');
    const selectedOption = rowElement.querySelector('.add-on-product__select option:checked');
    const rrpPriceElement = rowElement.querySelector('.add-on-product__price--rrp .sl-product-price');
    const wholesalePriceElement = rowElement.querySelector(
      '.add-on-product__price--wholesale .sl-product-price'
    );

    if (hiddenInput) {
      hiddenInput.value = quantityInput.value;
    }

    let quantity = parseInt(quantityInput.value);

    if (quantity === 0 || quantity === 1) {
      quantity = 1;
    }

    let variantPrice, variantWholesalePrice;

    if (selectedOption) {
      variantPrice = parseFloat(selectedOption.getAttribute('data-add-on-variant-price'));
      variantWholesalePrice = parseFloat(selectedOption.getAttribute('data-add-on-variant-wholesale-price'));
    } else {
      variantPrice = parseFloat(rowElement.querySelector('[data-add-on-variant-price]').dataset.addOnVariantPrice);
      variantWholesalePrice = parseFloat(
        rowElement.querySelector('[data-add-on-variant-wholesale-price]').dataset.addOnVariantWholesalePrice
      );
    }

    rrpPriceElement.innerHTML = formatPrice(parseFloat(variantPrice) * quantity);

    if (variantWholesalePrice && wholesalePriceElement) {
      wholesalePriceElement.innerHTML = formatPrice(parseFloat(variantWholesalePrice) * quantity);
    }
  };

  function updateAddOnsTotal() {
    const addOnRows = document.querySelectorAll('.product-add-ons .add-on-product');
    let totalAddOnsPrice = 0;

    addOnRows.forEach(row => {
      const hiddenInput = row.querySelector('.add-on-product__quantity');
      const selectedOption = row.querySelector('.add-on-product__select option:checked');

      let variantPrice = 0;
      if (selectedOption) {
        // If there's a selected option, get the price from there
        variantPrice = parseFloat(selectedOption.getAttribute('data-add-on-variant-price'));
        if (discountMultiplier) {
          variantPrice = parseFloat(variantPrice * discountMultiplier);
        }
      } else {
        // If there's no selected option but there's a variant price data attribute directly on the row
        const rowVariantPrice = row.querySelector('[data-add-on-variant-price]').dataset.addOnVariantPrice;
        if (rowVariantPrice) {
          variantPrice = parseFloat(rowVariantPrice);
          if (discountMultiplier) {
            variantPrice = parseFloat(variantPrice * discountMultiplier);
          }
        }
      }

      totalAddOnsPrice += variantPrice * parseInt(hiddenInput.value);
    });

    const addOnsAmountElement = document.querySelector('.summary-row__add-ons .summary-row__amount');
    addOnsAmountElement.innerHTML = formatPriceShort(totalAddOnsPrice);
    updateTotalSummary();
  }

  const updateMaxQuantity = function (rowElement, selectedOption = null) {
    const quantityInput = rowElement.querySelector('[data-add-on-quantity-input]');
    const incrementButton = rowElement.querySelector('[data-add-on-quantity-plus]');
    const decrementButton = rowElement.querySelector('[data-add-on-quantity-minus]');
    let errorMessage = rowElement.querySelector('.error-message') || document.createElement('p');

    errorMessage.className = 'error-message';
    errorMessage.style.color = 'red';

    let inventoryQuantity, availability;

    if (selectedOption) {
      inventoryQuantity = selectedOption.getAttribute('data-add-on-variant-inventory-quantity');
      availability = selectedOption.getAttribute('data-add-on-variant-available');
    } else {
      inventoryQuantity = rowElement.querySelector('[data-add-on-variant-inventory-quantity]').dataset
        .addOnVariantInventoryQuantity;
      availability = rowElement.querySelector('[data-add-on-variant-available]').dataset.addOnVariantAvailable;
    }

    if (availability === 'false') {
      quantityInput.disabled = true;
      incrementButton.disabled = true;
      rowElement.classList.add('out-of-stock');
    } else {
      if (inventoryQuantity !== 'null') {
        quantityInput.max = inventoryQuantity;
      } else {
        quantityInput.removeAttribute('max');
      }
      quantityInput.disabled = false;
      incrementButton.disabled = false;
      rowElement.classList.remove('out-of-stock');
    }

    if (parseInt(quantityInput.value) >= parseInt(quantityInput.max)) {
      incrementButton.disabled = true;
      incrementButton.closest('.add-on-quantity-selector__button-wrapper').classList.add('add-on-quantity-selector__button-wrapper--disabled');
      errorMessage.textContent = `Maximum quantity purchasable is ${quantityInput.max}`;
      if (!rowElement.querySelector('.error-message')) {
        rowElement.querySelector('.add-on-product__variant').appendChild(errorMessage);
      }
    } else {
      incrementButton.disabled = false;
      incrementButton.closest('.add-on-quantity-selector__button-wrapper').classList.remove('add-on-quantity-selector__button-wrapper--disabled');
      if (rowElement.querySelector('.error-message')) {
        rowElement.querySelector('.error-message').remove();
      }
    }
  };

  quantitySelectors.forEach(function (selector) {
    const incrementButton = selector.querySelector('[data-add-on-quantity-plus]');
    const decrementButton = selector.querySelector('[data-add-on-quantity-minus]');
    const quantityInput = selector.querySelector('[data-add-on-quantity-input]');

    function setButtonState(button, state) {
        button.disabled = state;
        const buttonWrapper = button.closest('.add-on-quantity-selector__button-wrapper');
        const action = state ? 'add' : 'remove';
        buttonWrapper.classList[action]('add-on-quantity-selector__button-wrapper--disabled');
    }

    function updateButtonStates(currentQuantity) {
        if (currentQuantity === 0) {
            setButtonState(decrementButton, true);
            setButtonState(incrementButton, false);
        } else if (currentQuantity === parseInt(quantityInput.max)) {
            setButtonState(decrementButton, false);
            setButtonState(incrementButton, true);
        } else {
            setButtonState(decrementButton, false);
            setButtonState(incrementButton, false);
        }
    }

    function handleQuantityChange(currentQuantity) {
        updateButtonStates(currentQuantity);
        updateMaxQuantity(selector.closest('.add-on-product'));
        updatePrice(selector.closest('.add-on-product'));
        updateAddOnsTotal();
    }

    incrementButton.addEventListener('click', function () {
        let currentQuantity = parseInt(quantityInput.value);
        if (!quantityInput.max || currentQuantity < parseInt(quantityInput.max)) {
            quantityInput.value = currentQuantity + 1;
            handleQuantityChange(currentQuantity + 1);
        }
    });

    decrementButton.addEventListener('click', function () {
        let currentQuantity = parseInt(quantityInput.value);
        if (currentQuantity > 0) {
            quantityInput.value = currentQuantity - 1;
            handleQuantityChange(currentQuantity - 1);
        }
    });

    quantityInput.addEventListener('input', function () {
        handleQuantityChange(parseInt(quantityInput.value));
    });

    updateMaxQuantity(selector.closest('.add-on-product'));
  });


  variantSelectors.forEach(function (selector) {
    const hiddenVariantInput = selector.closest('.add-on-product__variant').querySelector('.add-on-product__input');

    selector.addEventListener('change', function () {
      if (hiddenVariantInput) {
        hiddenVariantInput.value = selector.value;
      }
      checkAvailability(selector.closest('.add-on-product'), selector.querySelector('option:checked'));
      updateMaxQuantity(selector.closest('.add-on-product'), selector.querySelector('option:checked'));
      updatePrice(selector.closest('.add-on-product'));
      updateAddOnsTotal();
    });
  });


  // PRODUCT FORM LISTENERS
  const variantSelect = document.querySelector('.variant-selection__variants[data-variants]');
  const quantityInput = document.querySelector('.quantity-selector__input[data-quantity-input]');
  const plusButton = document.querySelector('.quantity-selector__button--plus');
  const minusButton = document.querySelector('.quantity-selector__button--minus');

  // Function to get the selected variant's price
  function getSelectedVariantPrice() {
    let selectedVariantPrice = 0;
    
    const selectedOption = variantSelect.querySelector('option:checked');
    if (selectedOption) {
      selectedVariantPrice = window.theme.productAddOns.variants[selectedOption.value].price;
    } else {
      const variantId = variantSelect.value;
      selectedVariantPrice = window.theme.productAddOns.variants[variantId].price;
    }
     
    if (tagMatchFound) {
      return (selectedVariantPrice / taxDivisor);
    } else {
      return selectedVariantPrice;
    }
  }

  // Function to update the total based on current quantity and price (with discount)
  function updateProductTotalSummary() {
    setTimeout(function () {
      const selectedVariantPrice = getSelectedVariantPrice();
      const roundedVariantPrice = parseInt(selectedVariantPrice)
      const quantity = parseInt(quantityInput.value, 10);
      const productAmountElement = document.querySelector('.summary-row__product .summary-row__amount');

      let productPrice = roundedVariantPrice * quantity;
      if (discountMultiplier < 1) {
        productPrice = getDiscountedPrice(productPrice, discountMultiplier);
      }

      productAmountElement.innerHTML = formatPriceShort(productPrice);
      updateTotalSummary();
    }, 80); // Delay of 80ms should be sufficient, but can be adjusted if needed
  }

  // Event listeners
  quantityInput.addEventListener('input', updateProductTotalSummary); // for direct input
  quantityInput.addEventListener('change', updateProductTotalSummary); // for changes like pasting values
  plusButton.addEventListener('click', updateProductTotalSummary);
  minusButton.addEventListener('click', updateProductTotalSummary);

  const variantOptionWrappers = document.querySelectorAll('[data-variant-option-value-wrapper]');
  if (variantOptionWrappers.length > 0) {
    variantOptionWrappers.forEach(wrapper => {
      wrapper.addEventListener('click', updateProductTotalSummary);
    });
  }



});
